var _span;
import React from 'react';
const _createElement = /*#__PURE__*/React.createElement;
import cls from 'classnames';
import { isMobile } from '@ali/dingtalk-jsapi/plugin/environmentV2';
import { Lightbulbfull20 } from '@ali/we-icons';
import { getImgCSSVarName } from "../helper";
import { Container } from "./styles";
export const BaseEmpty = _ref => {
  let {
    className,
    style,
    theme,
    full,
    platform = isMobile() ? 'mobile' : 'desktop',
    type,
    title,
    desc,
    tip,
    tipSuffix,
    actions,
    screenCenter,
    'data-testid': dataTestId = 'empty-container',
    Button,
    tag
  } = _ref;
  const actionsNode = React.useMemo(() => {
    if (typeof actions === 'function') {
      return actions();
    }
    if (Array.isArray(actions)) {
      if (!Button) {
        return null;
      }
      return actions == null ? void 0 : actions.map(item => {
        const {
          type,
          style,
          onClick,
          className,
          text
        } = item;
        return /*#__PURE__*/_createElement(Button, {
          key: item.key,
          type: type,
          style: style,
          onClick: onClick,
          className: className
        }, text);
      });
    }
    if (actions) {
      return actions;
    }
    return null;
  }, [Button, actions]);

  /**
   * @summary 统一空态组件
   * @see {@link https://alidocs.dingtalk.com/i/nodes/jb9Y4gmKWrx9eo4dCNloKqN4JGXn6lpz}
   * @author 欣光
   * @description 统一空态，如有变更可以先找「欣光」商讨，需要对齐该文档和设计稿，底层空态组件，改动造成的影响面会很大
   */

  return /*#__PURE__*/_createElement(Container, {
    "data-testid": dataTestId,
    className: cls(className, platform, theme, {
      full,
      'screen-center': screenCenter
    }),
    style: style,
    "data-tag": tag
  }, /*#__PURE__*/_createElement("div", {
    className: "empty-image",
    style: {
      backgroundImage: "var(" + getImgCSSVarName(type) + ")"
    }
  }), title && /*#__PURE__*/_createElement("div", {
    className: "empty-title"
  }, title), desc && /*#__PURE__*/_createElement("div", {
    className: "empty-desc"
  }, desc), actionsNode && /*#__PURE__*/_createElement("div", {
    className: "empty-actions"
  }, actionsNode), tip && /*#__PURE__*/_createElement("div", {
    className: "empty-tip"
  }, _span || (_span = /*#__PURE__*/_createElement("span", {
    className: "tip-icon"
  }, /*#__PURE__*/_createElement(Lightbulbfull20, null))), /*#__PURE__*/_createElement("span", {
    className: "tip-text"
  }, tip), tipSuffix));
};
BaseEmpty.displayName = 'BaseEmpty';
//# sourceMappingURL=index.js.map